import { render, staticRenderFns } from "./ReferralUploadResult.vue?vue&type=template&id=4d889794"
import script from "./ReferralUploadResult.vue?vue&type=script&lang=js"
export * from "./ReferralUploadResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports